module.exports = __webpack_public_path__ + "PTMETTAhome-9.f183e5db.png";